import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs/Rx'
import { DialogConfiguration } from '@mprep/shared/angular'

import { PathNode } from '@mprep/shared/data/models'

import { RESET_DIALOG_CONFIGURATION } from './reset-dialog.configuration'
import { PathResetService, SequencedDialogComponent } from '../../shared'
@Component({
  selector: 'mp-path-reset-dialog',
  template: '<mp-sequenced-dialog #sequenceDialog><mp-sequenced-dialog>'
})
export class PathResetDialogComponent implements OnInit, OnDestroy {
  private _pathRoot: PathNode

  @ViewChild('sequenceDialog')
  private _sequenceDialog: SequencedDialogComponent

  private _dialogSubscription: Subscription

  constructor(
    private _pathResetService: PathResetService
  ) {}

  public ngOnInit() {
    this._sequenceDialog.onContinue.subscribe(() => {
      this._pathResetService.resetPath(this._pathRoot).subscribe()
    })

    this._dialogSubscription = this._pathResetService.getResetEventEmitter().subscribe((pathRoot: PathNode) => {
      this.openDialog(pathRoot)
    })
  }

  public openDialog(pathRoot: PathNode) {
    this._pathRoot = pathRoot
    this._sequenceDialog.setSequence(this._getDialogSequence())
    this._sequenceDialog.open()
  }

  public ngOnDestroy() {
    this._dialogSubscription.unsubscribe()
  }

  private _getDialogSequence(): DialogConfiguration[] {
    return <DialogConfiguration[]> [
      RESET_DIALOG_CONFIGURATION.PROMPT, RESET_DIALOG_CONFIGURATION.SUCCESS
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/workspace/path-reset-dialog/path-reset-dialog.component.ts